export default "__VITE_ASSET__CCJv3iD2__"